import { Component, ElementRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

import { ButtonComponent, ButtonStyleEnumPipe, ButtonShapeEnumPipe, ButtonColorEnumPipe, ButtonSizeEnumPipe } from 'ui-library-shared';

@Component({
    selector: 'app-impersonate-user-cell',
    templateUrl: './impersonate-user-cell.component.html',
    styleUrls: ['./impersonate-user-cell.component.scss'],
    standalone: true,
  imports: [ButtonComponent, ButtonStyleEnumPipe, ButtonSizeEnumPipe, ButtonShapeEnumPipe, ButtonColorEnumPipe]
})
export class ImpersonateUserCellComponent implements ICellRendererAngularComp {
  private static lastTabShift = false;
  private static tabTrackerActive = false;
  public data: any;
  public originalData: any;
  public api: any;
  public rowIndex: number = -1;
  public emailConfirmed: boolean = null;
  public isActivated: boolean = null;
  public isDenied: boolean = null;
  public readOnly: boolean;
  public disabled: boolean = true;
  public isPrimaryOrg: boolean = true;

  constructor(private elementRef: ElementRef) { }

  public agInit(params: ICellRendererParams): void {
    this.applyRowState(params);

    if (!ImpersonateUserCellComponent.tabTrackerActive) {
      document.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Tab') ImpersonateUserCellComponent.lastTabShift = e.shiftKey;
      }, true);
      ImpersonateUserCellComponent.tabTrackerActive = true;
    }

    const agCell = (params.eParentOfValue as HTMLElement)?.closest('.ag-cell') as HTMLElement;
    if (agCell) {
      agCell.addEventListener('focus', () => this.focusIn());
    }
  }

  public refresh(params: ICellRendererParams): boolean {
    //Return true so ag-grid keeps this renderer instead of destroying and recreating it. When Tab
    //moves focus out of the row editor and into this cell, ag-grid refreshes the row immediately
    //afterwards, and a recreate would take the just-focused button out of the DOM, dropping focus
    //to the body and costing an extra Tab to reach the button.
    this.applyRowState(params);
    return true;
  }

  private applyRowState(params: ICellRendererParams): void {
    this.data = params.data;
    this.api = params.api;
    this.rowIndex = params.node.rowIndex;
    this.emailConfirmed = this.data.emailConfirmed;
    this.isActivated = this.data.isActivated;
    this.isDenied = this.data.isDenied;
    this.isPrimaryOrg = (this.data.primaryOrganizationId && this.data.organizationId === this.data.primaryOrganizationId);
    this.disabled = this.data.status !== "Active";
    if (this.data.status === "Locked") {
      this.disabled = !this.isActivated || this.isDenied || !this.isPrimaryOrg;
    }
  }

  public focusIn(): void {
    const container = this.elementRef.nativeElement.querySelector('.button-container') as HTMLElement;
    if (!container) return;
    const buttons = Array.from(container.querySelectorAll<HTMLButtonElement>('button:not([disabled])'));
    if (buttons.length === 0) return;
    const target = ImpersonateUserCellComponent.lastTabShift ? buttons[buttons.length - 1] : buttons[0];
    target.focus();
  }

  public onButtonTabKeyDown(event: KeyboardEvent): void {
    if (event.key !== 'Tab') return;
    const container = event.currentTarget as HTMLElement;
    const buttons = Array.from(container.querySelectorAll<HTMLButtonElement>('button:not([disabled])'));
    if (buttons.length <= 1) return;
    const currentIndex = buttons.indexOf(document.activeElement as HTMLButtonElement);
    if (currentIndex === -1) return;
    if (!event.shiftKey && currentIndex === buttons.length - 1) return;
    if (event.shiftKey && currentIndex === 0) return;
    event.preventDefault();
    event.stopPropagation();
    buttons[event.shiftKey ? currentIndex - 1 : currentIndex + 1].focus();
  }

  public impersonate() {
    if (this.api.onActionTrigger) {
      this.api.onActionTrigger({ row: this.rowIndex, action: "impersonate", data: this.data });
    } else {
      console.error("OnActionTrigger not defined");
    }
  }

}
